module.exports = __webpack_public_path__ + "static/media/batman-robin.ad64ece6.png";